import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { memo } from 'react';

/** Terminal hero for the confirm dialog — 72px status circle, ported 1:1 from
 * markets' `OrderTransactionDialog` (`ResultHeroIcon`). Only `success` is
 * rendered today; the `reverted` branch is kept so the copy stays exact. */
const ResultHeroIcon = t0 => {
  const $ = _c(8);
  const {
    status
  } = t0;
  const t1 = status === "success" ? "bg-success text-success-foreground" : "bg-destructive text-destructive-foreground";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex size-[72px] shrink-0 items-center justify-center rounded-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <circle cx="48" cy="48" r="38" stroke="currentColor" strokeWidth="5" strokeLinecap="round" style={{
      transform: "rotate(-90deg)",
      transformBox: "fill-box",
      transformOrigin: "center"
    }} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== status) {
    t4 = <svg className="size-[72px]" viewBox="0 0 96 96" fill="none">{t3}{status === "success" ? <path d="M31 49.5L43.2 61.5L66 36.5" stroke="currentColor" strokeWidth="5" strokeLinecap="butt" strokeLinejoin="round" /> : <path d="M34 34L62 62M62 34L34 62" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />}</svg>;
    $[3] = status;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div aria-hidden={true} className={t2}>{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default memo(ResultHeroIcon);